
export const PancakeStack = function (props: {
  children: [JSX.Element, JSX.Element, JSX.Element]
}) {
  return (
    <div
      style={{
        height: "100%",
        display: "grid",
        gridTemplateRows: "auto 1fr auto",
        overflow: "hidden",
      }}
    >
      {props.children[0]}
      <div style={{ overflow: "auto" }}>{props.children[1]}</div>
      {props.children[2]}
    </div>
  )
}
